import { useState, useEffect, useRef } from "react";
import { Grid, Stack, Button } from "@mui/material";
import Helpers from "../../helpers/helpers";
import CustomButton from "./CustomButton";

/** Small thumbnail uploader */
export default function ThumbnailUploader({ value, onChange }) {
  const [preview, setPreview] = useState(value ?? "");
  const fileInputRef = useRef();

  useEffect(() => {
    if (value) {
      setPreview(value);
    }
  }, [value]);

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    // const url = URL.createObjectURL(file);
    Helpers.getPreviewBase64(file, (result) => {
      setPreview(result);
      onChange?.({
        file: file,
        file_base64: result,
        file_name: file.name,
        file_type: file.type,
      });
    })
    fileInputRef.current.value = null;
  };

  const handleRemoveUploadedFile = () => {
    setPreview("");
    onChange?.("");
  }

  return (
    <Stack direction={preview ? "column" : "row"} spacing={2} alignItems={preview ?  "flex-start" : "center"}>
      {/* Square preview with upload icon fallback */}
      <label htmlFor="thumbnail-input" style={{ cursor: "pointer" }}>
        <div
          style={{
            width: 140,
            height: 140,
            borderRadius: preview ? 0 : 12,
            border: "1px solid #E5E7EB",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            background: "#fff",
          }}
        >
          {preview ? (
            <img
              src={preview?.file_base64}
              alt="Thumbnail preview"
              style={{ width: 140, height: 140, objectFit: "contain", }}
            />
          ) : (
            <i className="ri-upload-2-line" style={{ fontSize: 20, color: '#7D7D7D' }} />
          )}
        </div>
      </label>

      <div>
        <input
          id="thumbnail-input"
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleFile}
          ref={fileInputRef}
        />
        {
          !preview ?
            <label htmlFor="thumbnail-input" style={{ display: 'inline-block' }}>
              <div
                role="button"
                tabIndex={0}
                aria-label="Upload Image"
                onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && document.getElementById('thumbnail-input')?.click()}
                style={{
                  padding: '8px 16px',
                  borderRadius: 10,
                  cursor: 'pointer',
                  userSelect: 'none',
                  background: '#F8F8F8',
                  color: '#1F2A44',
                  fontWeight: 500,
                  lineHeight: 1.2,
                  display: 'inline-block',
                  boxShadow: 'inset 0 0 0 0.1px rgba(0,0,0,0.06)',
                }}
                onMouseDown={(e) => (e.currentTarget.style.transform = 'translateY(1px)')}
                onMouseUp={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
              >
                Upload a picture
              </div>
            </label>
            : <CustomButton
              title={'Remove Image'}
              backgroundColor={'white'}
              borderStyle={'1px solid #1D1B1B'}
              textColor={'#1D1B1B'}
              press={() => handleRemoveUploadedFile()}
            />
        }

      </div>
    </Stack>
  );
}
